import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string
};

var FormContainer = /*#__PURE__*/function (_Component) {
  _inherits(FormContainer, _Component);

  var _super = _createSuper(FormContainer);

  function FormContainer(props) {
    var _this;

    _classCallCheck(this, FormContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_validateFormData", function (serializedForm, stateData) {
      if (!serializedForm) return stateData;
      var formKeys = Object.keys(serializedForm);
      var finalData = stateData;

      for (var _i = 0, _formKeys = formKeys; _i < _formKeys.length; _i++) {
        var key = _formKeys[_i];
        if (!stateData[key] && serializedForm[key]) finalData[key] = serializedForm[key];
      }

      return finalData;
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", function (event) {
      if (!_this.props.action) event.preventDefault();
      var form = event.currentTarget;
      var serializedForm = serialize(form, {
        hash: true,
        empty: true
      });
      var stateData = _this.state.form;

      var submitData = _this._validateFormData(serializedForm, stateData);

      _this.props.onSubmit && _this.props.onSubmit(submitData);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleInputChange", function (event) {
      var target = event.target;
      var value = target.type === 'checkbox' ? target.checked : target.dataset.truevalue !== '' ? target.dataset.truevalue : target.value;
      var name = target.name;

      if (name) {
        _this.setState({
          form: _objectSpread(_objectSpread({}, _this.state.form), {}, _defineProperty({}, name, value))
        });
      }

      _this.props.onChange && _this.props.onChange(event);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleReset", function (event) {
      _this.setState({
        form: {},
        key: Number(!_this.state.key)
      });

      _this.props.onReset && _this.props.onReset(event);
    });

    _this.state = {
      form: {},
      key: 0
    };
    return _this;
  }

  _createClass(FormContainer, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("form", _extends({}, this.props, {
        id: this.props.id,
        style: this.props.style,
        onSubmit: this._handleSubmit,
        onChange: this._handleInputChange,
        onReset: this._handleReset,
        key: this.state.key
      }), this.props.children);
    }
  }]);

  return FormContainer;
}(Component);

FormContainer.propTypes = propTypes;
export default withVDSManager(FormContainer);